// src/components/effects/TypewriterSearch.jsx
// Buscador cuyo placeholder se escribe y borra solo (kit: .buscador-demo).
import { useEffect, useRef, useState } from "react";

const DEFAULT_PHRASES = [
  "Buscar «Laura Giménez»…",
  "Contactos sin respuesta hace 5 días…",
  "Clínicas dentales en Madrid…",
  "Mensajes enviados por LinkedIn…",
];

export default function TypewriterSearch({ value, onChange, phrases = DEFAULT_PHRASES, label = "Buscar contactos, empresas o mensajes", shortcut = "⌘K" }) {
  const [shown, setShown] = useState("");
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) { setShown(phrases[0]); return; }
    let alive = true;
    const wait = (ms) => new Promise((r) => setTimeout(r, ms));
    (async () => {
      for (let i = 0; alive; i = (i + 1) % phrases.length) {
        const f = phrases[i];
        for (let k = 1; k <= f.length && alive; k++) { setShown(f.slice(0, k)); await wait(55 + Math.random() * 60); }
        await wait(1600);
        for (let k = f.length; k >= 0 && alive; k--) { setShown(f.slice(0, k)); await wait(24); }
        await wait(300);
      }
    })();
    return () => { alive = false; };
  }, [phrases]);

  useEffect(() => {
    const onKey = (e) => { if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") { e.preventDefault(); inputRef.current?.focus(); } };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const showOverlay = !focused && !value;
  return (
    <label className="ca-search">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
      <input ref={inputRef} aria-label={label} value={value} onChange={(e) => onChange?.(e.target.value)} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} />
      {showOverlay && <span className="ca-search-tw" aria-hidden="true">{shown}</span>}
      <span className="ca-kbd" aria-hidden="true">{shortcut}</span>
    </label>
  );
}
